import React, { useState, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n';
import "./styleInfo.css"

import Info from './Info';
// import Privacy from "./Privacy";

function Main() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // Функция для проверки активного языка
    const isActive = (lng) => i18n.language === lng ? "lang-btn active" : "lang-btn";

    return (
        <div className="app-container">
            <header className="main-header">
                <div className="language-switcher">
                    {['ru', 'ua', 'en', 'es'].map((lang) => (
                        <button
                            key={lang}
                            className={isActive(lang)}
                            onClick={() => changeLanguage(lang)}
                        >
                            {lang.toUpperCase()}
                        </button>
                    ))}
                </div>
            </header>

            <Routes>
                <Route path="/" element={<Info/>} />
                {/*<Route path="/privacy" element={<Privacy/>} />*/}
            </Routes>

            {/*<footer>*/}
            {/*    <h1>{t("legal.footer_copy")}</h1>*/}
            {/*    <button*/}
            {/*        style={{color: "white", backgroundColor: "transparent", border: "none", textDecoration: "underline", cursor: "pointer"}}*/}
            {/*        onClick={() => navigate("/privacy")}>*/}
            {/*        {t("legal.policy_link")}*/}
            {/*    </button>*/}
            {/*</footer>*/}
        </div>
    );
}

const root = createRoot(document.getElementById("root"));
root.render(
    <StrictMode>
        <BrowserRouter>
            <Main />
        </BrowserRouter>
    </StrictMode>
);
